<template>
  <div class="reimbursement">
    <van-sticky :offset-top="0">
      <div class="header">
        <l-header url="/" headerTitle="我的报销"></l-header>
        <div class="query">
          <div class="top">
            <div class="popup-time" @click="handleChoice('time')"><div class="time">{{queryDateTitle}}</div><div class="division"></div><span class="top-icon huisuiyunfont">{{'\ue633'}}</span></div>
          </div>
          <div class="bottom">
            <div>
              <l-tab
                :tabList="tabList"
                isBlueLine
                backgroundColor="#fff"
                titleActiveColor="#3378FF"
                titleInactiveColor="#7A8699"
                :handleChange="handleChange"
              ></l-tab>
            </div>
          </div>
        </div>
      </div>
    </van-sticky>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item, index) in reimList" :key="index" @click="handleGetInfo(item.reimNo)">
            <l-card>
              <template v-slot:leftTop>
                {{item.reimReason}}
              </template>
              <template v-slot:leftBottom>
                <div class="reim">
                  <div v-if="Number(item.reimStatus) === 1" :class="getColorByState(item.reimStatus)">
                    <span class="icon padding huisuiyunfont">{{'\ue66e'}}</span>
                    <span class="font-w">审批中</span>
                  </div>
                  <div v-else-if="Number(item.reimStatus) === 2" :class="getColorByState(item.reimStatus)">
                    <span class="icon huisuiyunfont">{{'\ue66d'}}</span>
                    <span class="font-w">已完成</span>
                  </div>
                  <div v-else-if="Number(item.reimStatus) === 3" :class="getColorByState(item.reimStatus)">
                    <span class="icon back huisuiyunfont">{{'\ue66c'}}</span>
                    <span class="font-w">已驳回</span>
                  </div>
                  <div class="reim-time">{{getTime(item.submitTime)}}</div>
                </div>
              </template>
              <template v-slot:right>
                {{Number(item.reimAmount).toFixed(2)}}
              </template>
            </l-card>
          </div>
        </van-list>
       </van-pull-refresh>
    </div>
    <l-popup :show.sync="monthPopup" :callBack="monthCallBack"></l-popup>
    <l-popup :show.sync="typePopup" :callBack="typeCallBack"></l-popup>
  </div>
</template>
<script>
import Header from '@/components/Header/index.vue'
import Tab from '@/components/Tab/index.vue'
import Card from './Card.vue'
import moment from 'moment'
import Popup from '@/components/NewPopup/index.vue'
import { Sticky, PullRefresh, List, Notify, Empty } from 'vant'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    'l-header': Header,
    'l-tab': Tab,
    'l-popup': Popup,
    'l-card': Card,
    [Sticky.name]: Sticky,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Notify.name]: Notify,
    [Empty.name]: Empty
  },
  computed: {
    ...mapState('reimModels', ['reimList', 'total']),
    getColorByState () {
      return (state) => {
        // reimbursed
        // 2 通过 2 审核 3 退回
        return state === 2 ? 'reimbursed'
          : state === 1 ? ['reimbursed', 'reviewed']
            : state === 3 ? ['reimbursed', 'return'] : 'reimbursed'
      }
    },
    getTime () {
      return (time) => {
        let d = time.split(' ')
        return d[0]
      }
    }
  },
  data () {
    return {
      queryTypeTitle: '全部类型',
      queryDateTitle: '请选择日期',
      isLoading: false,
      loading: false,
      finished: false,
      tabList: [
        {
          title: '全部',
          index: 0
        }, {
          title: '审批中',
          index: 1
        }, {
          title: '已驳回',
          index: 2
        }, {
          title: '已完成',
          index: 3
        }
      ],
      monthPopup: {
        flag: false,
        selectTitle: '请选择月份',
        style: { height: '50%' },
        type: 'month'
      },
      typePopup: {
        flag: false,
        selectTitle: '请选择类型',
        style: { height: '50%' },
        type: 'invoiceType'
      },
      query: {
        current: 1,
        size: 7,
        submitStartTime: '',
        submitEndTime: '',
        reimStatus: '',
        invoiceType: '',
        type: '1'
      }
    }
  },
  methods: {
    ...mapActions('reimModels', ['getReimList', 'getReimListPage']),
    async onLoad () {
      this.finished = true
      this.loading = true
      this.query.current++
      this.loading = true
      await this.getReimListPage(this.query)
      console.log(this.total)
      if (this.reimList.length >= this.total) {
        this.finished = true
        this.loading = true
      } else {
        this.finished = false
        this.loading = false
      }
    },
    handleGetInfo (reimNo) {
      this.$router.push({ path: '/my-examine/page', query: { reimNo } })
    },
    onRefresh () {
      setTimeout(async () => {
        await this.handleGetList()
      }, 1000)
    },
    handleChoice (type) {
      if (type === 'type') {
        this.typePopup.flag = true
      } else if (type === 'time') {
        this.monthPopup.flag = true
      }
    },
    async handleGetList () {
      this.query.current = 1
      await this.getTableList()
      this.isLoading = false
      this.finished = false
    },
    async handleChange (v) {
      console.log(v)
      switch (v) {
        case 1:
          this.query.reimStatus = 1
          break
        case 2:
          this.query.reimStatus = 3
          break
        case 3:
          this.query.reimStatus = 2
          break
        default:
          this.query.reimStatus = ''
          break
      }
      await this.handleGetList()
    },
    async typeCallBack (v) {
      console.log(v)
      this.typePopup.flag = false
      if (v === 'recovery') {
        this.queryTypeTitle = '全部类型'
        this.query.invoiceType = ''
        await this.handleGetList()
        return
      }
      this.queryTypeTitle = v.title
      this.query.invoiceType = v.index
      await this.handleGetList()
    },
    async monthCallBack (v) {
      this.monthPopup.flag = false
      if (v === 'recovery') {
        this.queryDateTitle = '请选择日期'
        this.query.submitStartTime = ''
        this.query.submitEndTime = ''
        await this.handleGetList()
        return
      }
      if (v.title) {
        this.queryDateTitle = moment(`${v.id}/${v.index}/1`).format('YYYY年MM月')
        this.query.submitStartTime = v.id + '-' + (v.index >= 10 ? v.index : '0' + v.index) + '-' + '01'
        if (v.index === 12) {
          this.query.submitEndTime = (Number(v.id) + 1) + '-' + '01' + '-' + '01'
        } else {
          this.query.submitEndTime = v.id + '-' + ((Number(v.index) + 1) >= 10 ? (Number(v.index) + 1) : '0' + (Number(v.index) + 1)) + '-' + '01'
        }
      } else {
        this.queryDateTitle = moment(`${moment().format('YYYY')}/${v}/1`).format('YYYY年MM月')
        this.query.submitStartTime = moment().format('YYYY') + '-' + (v >= 10 ? v : '0' + v) + '-' + '01'
        if (v === 12) {
          this.query.submitEndTime = (Number(moment().format('YYYY')) + 1) + '-' + '01' + '-' + '01'
        } else {
          this.query.submitEndTime = moment().format('YYYY') + '-' + ((Number(v) + 1) >= 10 ? (Number(v) + 1) : '0' + (Number(v) + 1)) + '-' + '01'
        }
      }
      await this.handleGetList()
    },
    async getTableList () {
      this.loading = true
      this.query.current = 1
      await this.getReimList(this.query)
      this.loading = false
    }
  },
  mounted () {
    this.getTableList()
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
